<template>
  <div class="home-body hmbg">
    <template v-if="$route.query && $route.query.newsTop">
      <content-box></content-box>
    </template>
    <template v-else>
      <div class="hmbg_head">
        <div class="backTop">
          <div class="home-header">
            <div class="widAuto">
              <div class="mainBox" :class="isPc ? 'flexlr ' : ''">
                <div class="home-logo"></div>
                <div class="home-user" v-if="showH5">
                  <button v-if="!sessionId" @click="goLogin" class="loginBtn">
                    登录入口
                  </button>
                  <el-popover
                    v-if="sessionId"
                    placement="bottom"
                    width="50"
                    style="cursor: pointer"
                    trigger="click"
                  >
                    <span class="loginout" @click="gologout">退出</span>
                    <span slot="reference">
                      <span class="f12 noSelect fontColorFFF">{{
                        userName
                      }}</span>
                      <i class="el-icon-caret-bottom fontColorFFF"></i>
                    </span>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
          <main class="mainBox">
            <!-- <header class="boxSizing w100">
          <div>
            <div class="headerMenu">
              <ul class="headerUl">
                <li v-for="(item, index) in menuData" :class="$route.path.split('/')[1] == item.nameUrl ? 'activeMenu' : ''" :style="index == menuData.length - 1 ? '' : 'border-right: 1px solid #fff;'">
                  <router-link :to="{ path: item.url }" :key="item.url">{{ item.name }}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </header>-->
            <router-view></router-view>
          </main>
        </div>
      </div>
      <footer class="homeFooter footbgc">
        <p>主办单位：安徽省高校网络思想政治工作中心</p>
        <p>技术支持：安徽力瀚科技有限公司</p>
        <p>
          为了获得更好的使用体验，建议使用谷歌Chrome浏览器或360极速浏览器访问本系统
        </p>
      </footer>
    </template>
  </div>
</template>
<script>
import { logout, authUser } from "@/api/login";
import { getQueryString, IsPC } from "@/utils/util";
import { setCookie, getCookie, removeCookie, removeSave } from "@/utils/auth";
import contentBox from "@/components/content/idnex.vue";
export default {
  components: { contentBox },
  computed: {
    userName: function() {
      this.account = getCookie("User-Name");
      return getCookie("User-Name");
    }
  },
  data() {
    return {
      isPc: IsPC(),
      menuData: [
        { name: "首页", url: "/home", nameUrl: "home" },
        { name: "新闻中心", url: "/news/73", nameUrl: "news" },
        { name: "优秀案例", url: "/plan", nameUrl: "plan" },
        { name: "精品课程", url: "/curriculum", nameUrl: "curriculum" },
        { name: "正能量库", url: "/events", nameUrl: "events" }
      ],
      authShow: false,
      urlData: {
        orgid: "",
        param: "",
        timestamp: ""
      },
      sessionId: getCookie("Session-Id"),
      showH5: true
    };
  },
  mounted() {
    // this.getUrlRule();
    // 判断是移动端还是pc  登录只有pc端有
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      // 手机端
      this.showH5 = false;
    } else {
      this.showH5 = true;
      // PC端
    }
  },
  methods: {
    // 判断来源
    getUrlRule() {
      this.urlData.orgid = getQueryString("orgid");
      this.urlData.param = getQueryString("param");
      this.urlData.timestamp = getQueryString("timestamp");
      if (this.urlData.orgid && this.urlData.param && this.urlData.timestamp) {
        authUser(this.urlData)
          .then(res => {
            if (res.data.authStatus == -1) {
              // 校验失败 普通登录  跳转登录页面
              removeSave();
              this.$router.push({
                // path: "/login"
                path: "/authLogin"
              });
              location.reload();
            } else if (res.data.authStatus == 0) {
              // 校验成功但需重新授权  没有授权  跳转授权页面
              localStorage.setItem(
                "authData",
                JSON.stringify(res.data.authData)
              );
              removeSave();
              this.$router.push({
                path: "/authLogin"
              });
              // location.reload();
            } else if (res.data.authStatus == 1) {
              // 已授权 可以在当前页面点 后台自动登录过了
              var sessinonData = res.data.session;
              removeSave();
              setCookie("user-Id", sessinonData.userid);
              setCookie("Session-Id", sessinonData.sessionid);
              setCookie("User-Name", sessinonData.username);
              setCookie("Org-User", sessinonData.accflag);
              setCookie("roles-User", JSON.stringify(sessinonData.roles));
              setCookie(
                "organ-Ids",
                JSON.stringify(sessinonData.organids[0].orgname)
              );
              setCookie(
                "second-orgId",
                JSON.stringify(sessinonData.secondOrgId)
              );
              this.sessionId = getCookie("Session-Id");
              this.authShow = true;
            }
          })
          .catch(() => {
            removeSave();
            this.$router.push({
              path: "/login"
            });
            location.reload();
          });
      } else {
        this.authShow = true;
      }
    },
    goLogin() {
      // this.$router.push({
      //     path: "/login"
      //   });
      window.location.href = window.location.origin + "/login";
      // location.href="http://test.app.com/login";
    },
    gologout() {
      logout().then(res => {
        // this.$router.push({
        //   path: "/"
        // });
        removeSave();
        if (res.data) {
          // window.location.href =
          //   window.location.origin +
          // "/Shibboleth.sso/Logout?return=" +
          // res.data;
          // console.log(res.data);

          window.open(res.data, "_self");
        }
        // location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/view/index.vue